import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CombinedReducersType, CmsContentActions } from "@redux/reducer";
import { CMSComponentSchema } from "@type/index";
import CMSComponents from "@util/cms";
import { parseComponent } from "@util/cms/parser";

// CMS returns height/width for the app, which forces the web banner into a
// fixed-height image. Strip them so the web banner stays responsive and fills
// its parent width, with the aspect ratio driven by the CMS ratio.
const removeFixedDimensions = (
  components: Array<CMSComponentSchema>
): Array<CMSComponentSchema> =>
  components.map((component) => {
    const nextComponent: CMSComponentSchema = { ...component };
    if (nextComponent._type === "CmsImage") {
      delete nextComponent.height;
      delete nextComponent.width;
    }
    Object.keys(nextComponent).forEach((key) => {
      const value = nextComponent[key];
      if (
        Array.isArray(value) &&
        value.some((child: any) => child && child._type)
      ) {
        nextComponent[key] = removeFixedDimensions(value);
      }
    });
    return nextComponent;
  });

type IProps = {
  type: string;
  className?: string;
};

const StyleHintBanner = (props: IProps) => {
  const { type, className } = props;
  const dispatch = useDispatch();
  const cmsContent = useSelector(
    (store: CombinedReducersType) => store.cmsContent
  );

  useEffect(() => {
    let _path = "";
    if (type === "top") {
      // top page
      _path = "/stylingbook/stylehint";
    } else if (type === "detail") {
      // detail page
      _path = "/styledetail";
    }
    // fetch banner api
    dispatch(
      CmsContentActions.getCmsBanner({
        path: _path,
        device: "RS"
      })
    );
  }, [dispatch, type]);

  const renderCmsContent = () => {
    const styleDetail =
      cmsContent[type === "top" ? "/stylingbook/stylehint" : "/styledetail"];
    if (!styleDetail?.length) {
      return null;
    }
    const content =
      type === "detail" ? removeFixedDimensions(styleDetail) : styleDetail;
    const cmsComponentMarkup = parseComponent(content, CMSComponents);

    return className ? (
      <div className={className}>{cmsComponentMarkup}</div>
    ) : (
      <>{cmsComponentMarkup}</>
    );
  };

  return <>{renderCmsContent()}</>;
};

export default StyleHintBanner;
